var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.2 20.4",
    style: {
      enableBackground: "new 0 0 15.2 20.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D1D1D1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message_chat",
    transform: "translate(-93.024 -6.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48617",
    className: "st0",
    d: "M102.4,10.7c-3.2,0-5.8,2.1-5.8,4.7c0,1.5,0.8,2.8,2,3.6c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.3,0.5-0.1,1.2,0.4,1.5c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.2,0,0.3,0c0.8-0.2,1.6-0.5,2.2-1.1c0.2,0,0.4,0,0.6,0 c3.2,0,5.8-2.1,5.8-4.7S105.6,10.7,102.4,10.7L102.4,10.7z M99.9,18.9l0.1-0.4l-0.4-0.2c-1.1-0.5-1.7-1.6-1.8-2.8 c0-1.9,2.1-3.5,4.6-3.5s4.6,1.6,4.6,3.5s-2.1,3.5-4.6,3.5c-0.3,0-0.5,0-0.8-0.1l-0.3,0l-0.2,0.2c-0.4,0.4-1,0.7-1.6,0.9 C99.8,19.6,99.9,19.2,99.9,18.9L99.9,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48618",
    className: "st0",
    d: "M100.9,15.6c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S100.9,15.2,100.9,15.6 L100.9,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48619",
    className: "st0",
    d: "M103.3,15.6c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S103.3,15.2,103.3,15.6 L103.3,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48620",
    className: "st0",
    d: "M105.7,15.6c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S105.7,15.2,105.7,15.6 L105.7,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48621",
    className: "st0",
    d: "M103.8,6.6h-9.4C93.7,6.6,93,7.2,93,8c0,0,0,0,0,0v17.4c0,0.8,0.7,1.5,1.5,1.5l0,0h9.4 c0.8,0,1.5-0.7,1.5-1.5c0,0,0,0,0,0v-4.9c-0.5,0.2-1.1,0.4-1.6,0.4v1.6h-9V9h9v0.8c0.6,0.1,1.1,0.2,1.6,0.4V8 C105.3,7.2,104.7,6.6,103.8,6.6C103.9,6.6,103.8,6.6,103.8,6.6L103.8,6.6z M99.2,23.7c0.5,0,1,0.4,1,1s-0.4,1-1,1c-0.5,0-1-0.4-1-1 c0,0,0,0,0,0C98.2,24.2,98.6,23.7,99.2,23.7C99.2,23.7,99.2,23.7,99.2,23.7z M101.2,8.2h-4.2c-0.1,0-0.2-0.2-0.2-0.4 s0.1-0.4,0.2-0.4h4.2c0.1,0,0.2,0.2,0.2,0.4S101.4,8.2,101.2,8.2L101.2,8.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageChat);
export default __webpack_public_path__ + "static/media/message_chat.3615561fc1e558e9993eee9efec6cbfb.svg";
export { ForwardRef as ReactComponent };